document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.pdw-arrow-valeur')) {
        document.querySelector('#valeur-next').addEventListener('click', () => {
            document.querySelector('.splide__arrow--next').click();
        });
        document.querySelector('#valeur-prev').addEventListener('click', () => {
            document.querySelector('.splide__arrow--prev').click();
        });
    }
});